// extracted by mini-css-extract-plugin
export var caret = "OTPInput-module--caret--6e9c3";
export var caretBlink = "OTPInput-module--caret-blink--d9418";
export var caretContainer = "OTPInput-module--caretContainer--1d96e";
export var containerOverride = "OTPInput-module--containerOverride--63b88";
export var hasError = "OTPInput-module--hasError--78e88";
export var inputValue = "OTPInput-module--inputValue--369c6";
export var isActive = "OTPInput-module--isActive--67301";
export var isLight = "OTPInput-module--isLight--2d2d2";
export var label = "OTPInput-module--label--36401";
export var otpError = "OTPInput-module--otpError--5686d";
export var otpErrorInner = "OTPInput-module--otpErrorInner--d178f";
export var otpSlot = "OTPInput-module--otpSlot--1f0a8";
export var overflowHidden = "OTPInput-module--overflowHidden--09245";